import { memo } from 'react'

import {
  OfficeInfoCard,
  OpenSearchForm,
  SearchResultCount,
  SelectSearchResultOrder,
  useSelectSearchResultOrder,
} from '~/features/common'
import { Office } from '~/models/types'

import { useMapContext, useMapDispatchContext } from '../../context'

import type { DrawerSearchContentProps } from './drawer-search-result'

type Props = Pick<
  DrawerSearchContentProps,
  'offices' | 'searchResultCount' | 'sortOrder' | 'changeSortOrder'
>

const DrawerSearchContentListComponent = ({
  offices,
  searchResultCount,
  sortOrder,
  changeSortOrder,
}: Props) => {
  const { isOpenDrawer } = useMapContext()
  const { onClickOfficeCard, onClickGoToList, openSearchForm } =
    useMapDispatchContext()
  const { onSelect, open, placeholder, searchResultOrders, setOpen } =
    useSelectSearchResultOrder(sortOrder, changeSortOrder)

  const handleListOpenClick = () => {
    onClickGoToList()
  }

  const handleOfficeCardClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    office: Office,
  ) => {
    e.preventDefault()
    onClickOfficeCard(office)
  }

  return (
    <div className="h-full w-full overflow-scroll bg-white px-4 pb-4 pt-2 shadow-lg">
      <div className="flex flex-row items-center justify-between gap-2">
        {!isOpenDrawer ? (
          <button
            className="text-base leading-[140%] text-link hover:opacity-70"
            onClick={handleListOpenClick}
          >
            一覧を表示
          </button>
        ) : (
          <div className="flex flex-row items-center gap-2">
            <SearchResultCount
              count={searchResultCount}
              layout="row"
              preCountText=""
            />
            <SelectSearchResultOrder
              items={searchResultOrders}
              onSelect={onSelect}
              open={open}
              placeholder={placeholder}
              setOpen={setOpen}
              size="small"
            />
          </div>
        )}
        <OpenSearchForm
          className="w-[130px] whitespace-nowrap"
          onClick={openSearchForm}
        >
          条件検索
        </OpenSearchForm>
      </div>
      <ul>
        {offices.map((office, index) => (
          <li
            className="border-grayBorder [&:not(:last-child)]:border-b"
            key={index}
          >
            <OfficeInfoCard
              office={office}
              onClick={(e) => handleOfficeCardClick(e, office)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

export const DrawerSearchContentList = memo(DrawerSearchContentListComponent)
